// material-ui
import { Theme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";

// project import
import Profile from "./Profile";
import FullScreen from "./FullScreen";
import MobileSection from "./MobileSection";
import useConfig from "hooks/useConfig";
import { MenuOrientation } from "config";
import DrawerHeader from "layout/Dashboard/Drawer/DrawerHeader";
import { Skeleton, Typography } from "@mui/material";
import { useGetMenu } from "api/menu";
import SelectCommunity from "./Profile/SelectCommunity";
import { useState } from "react";

// ==============================|| HEADER - CONTENT ||============================== //

export default function HeaderContent() {
  const { communities, menuLoading, selectedCommunity: selectedCommunity } = useGetMenu();
  const { menuOrientation } = useConfig();
  const [community, setCommunity] = useState<{ id: number; name: string } | null>(
    null
  );

  const downLG = useMediaQuery((theme: Theme) => theme.breakpoints.down("lg"));

  return (
    <>
      {menuOrientation === MenuOrientation.HORIZONTAL && !downLG && (
        <DrawerHeader open={true} />
      )}
      <Typography sx={{ textWrap: "nowrap", mx: "8px" }} variant="h4">
        {menuLoading ? (
          <></>
        ) : communities != null &&
          communities.length > 0 &&
          selectedCommunity != undefined &&
          selectedCommunity != 0 ? (
          community != null ? (
            community?.name
          ) : (
            <Skeleton animation="wave" width={200} />
          )
        ) : (
          <></>
        )}
        {/* { !menuLoading  ? ((library != null && libraries?.length > 0) ? library?.name : "") : <Skeleton animation="wave" width={200} />} */}
      </Typography>
      {/* {!downLG && <Search />} */}
      {<Box sx={{ width: "100%" }} />}
      {!downLG && <FullScreen />}
      {/* <Customization /> */}
      <SelectCommunity setCommunity={setCommunity} />
      {!downLG && <Profile />}
      {downLG && <MobileSection />}
    </>
  );
}
